import type { ApiFetchFavoriteGamesPort } from './ports/api-fetch-favorite-games.port';

export class FetchFavoriteGamesHandler {
  // eslint-disable-next-line no-useless-constructor
  constructor(private apiFetchFavoriteGamesPort: ApiFetchFavoriteGamesPort) {}

  async handle(playerId: string) {
    return await this.apiFetchFavoriteGamesPort.handle(playerId);
  }
}
